import { getFullUrl } from 'hubspot-url-utils';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Flex } from 'foundations-components/components/Flex';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { getRepName, getUpgradeDataTrackingProperties } from '../../ums/utils';
import { getInlineMeetingParams } from '../common/api/meetingHelpers';
import { StyledModal } from '../common/components/StyledModal';
import { upgradeDataPropsInterface } from '../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { track } from '../common/eventTracking/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TRUSTED_DOMAINS = ['https://www.hubspot.com', 'https://hubspot.com', getFullUrl('app', {
  envOverride: 'prod'
}), getFullUrl('meetings', {
  envOverride: 'prod'
}), getFullUrl('meetings', {
  envOverride: 'qa'
})];
const StyledIframe = styled.iframe.withConfig({
  displayName: "MeetingModal__StyledIframe"
})(({
  theme
}) => ({
  border: theme.space['0'],
  width: '900px',
  height: '800px'
}));
const MeetingModal = ({
  hideBackground = false,
  onClose,
  upgradeData,
  repInfo,
  onBackClick
}) => {
  const {
    link: linkBase
  } = repInfo;
  const meetingLink = `${linkBase}?${getInlineMeetingParams(upgradeData, repInfo)}`;
  useEffect(() => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'shown booking page',
      meetingLink,
      repName: getRepName(repInfo)
    }, getUpgradeDataTrackingProperties(upgradeData)));
    const handleMessages = e => {
      const isKnownOrigin = TRUSTED_DOMAINS.includes(e.origin);
      if (!isKnownOrigin) return;
      if (e.data.meetingBookSucceeded) {
        track('communicationMethodsInteraction', Object.assign({
          action: 'meeting booked successfully',
          meetingLink,
          repName: getRepName(repInfo)
        }, getUpgradeDataTrackingProperties(upgradeData)));
      }
    };
    window.addEventListener('message', handleMessages);
    return () => window.removeEventListener('message', handleMessages);
  }, [upgradeData, meetingLink, repInfo]);
  return /*#__PURE__*/_jsxs(StyledModal, {
    "data-test-id": "meeting-modal",
    use: "conversational",
    width: 900,
    hideBackground: hideBackground,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        textAlign: "start",
        marginBlockStart: "-800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.meeting"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      })]
    }), onBackClick && /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      marginBlockStart: "400",
      marginBlockEnd: "400",
      marginInlineStart: "800",
      children: [/*#__PURE__*/_jsx(LeftIcon, {}), /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: () => {
          track('communicationMethodsInteraction', {
            action: 'back to other options from meeting modal'
          });
          onBackClick();
        },
        paddingInlineStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.backButton"
        })
      })]
    }), /*#__PURE__*/_jsx(StyledIframe, {
      id: "meetingModal",
      "data-test-id": "tts-modal",
      src: meetingLink
    })]
  });
};
MeetingModal.propTypes = Object.assign({
  hideBackground: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onBackClick: PropTypes.func,
  repInfo: PropTypes.object
}, upgradeDataPropsInterface);
export default MeetingModal;